import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export function minLengthDocumentValidator(min: number): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const value = (control.value as string)?.replace(/\D/g, '') ?? '';
    if (!value) return null;
    return value.length >= min ? null : { invalidDocument: true };
  };
}
